<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: AssetMap.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <!-- <div @mouseover="hover" @mouseleave="unhover" class="assets__map-wrapper"> -->
  <div class="assets__map-wrapper">
    <!-- <div v-if="showOverlay" @click="removeOverlay" class="assets__map-overlay">Click to interact with map</div> -->
    <!-- STATUS FILTER -->
    <div v-if="status" class="assets__map-filter-button status dropright">
      <button
        :title="!allStatusSelected ? 'Filtered by status' : 'Filter by status'"
        id="dropdown-status"
        class="btn-reset"
        :class="{ 'button-on': !allStatusSelected }"
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        data-flip="false"
      >
        <i class="assets__map-filter-icon icon-status2"></i>
      </button>
      <div class="dropdown-menu">
        <map-selector :type="'Status'" :filters="status" v-model="selectedStatus" @input="selectableChanged" />
      </div>
    </div>
    <!-- NETWORKS FILTER -->
    <div v-if="availableNetworksTree" class="assets__map-filter-button network dropright">
      <button
        :title="!allNetworksSelected ? 'Filtered by network' : 'Filter by network'"
        id="dropdown-network"
        class="btn-reset"
        :class="{ 'button-on': !allNetworksSelected }"
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        data-flip="false"
      >
        <i class="assets__map-filter-icon icon-sphere"></i>
      </button>
      <div class="dropdown-menu">
        <map-selector
          :type="'Networks'"
          :filters="availableNetworksTree"
          v-model="selectedNetworksTree"
          @input="selectableChanged"
        />
      </div>
    </div>

    <div class="assets__map-filter-button cluster">
      <button
        :title="clusterOn ? 'Cluster off' : 'Cluster on'"
        id="cluster"
        class="btn-reset"
        :class="{ 'button-on': clusterOn }"
        type="button"
        aria-haspopup="true"
        aria-expanded="false"
        @click="toggleCluster"
      >
        <i class="assets__map-filter-icon icon-group"></i>
      </button>
    </div>

    <div id="assets__map" class="assets__map-canvas" style="background: #75CFEF;">
      <!-- TEST FILTER -->
      <!-- <div v-if="selectedStations.length > 0" class="assets__map--stations-selected mb-2">
      <strong class="assets__map--text align-middle lh-lg">Add to filter: </strong>
      <span class="assets__map--text align-middle lh-lg" v-for="(station, idx) in selectedStations" :key="idx"
        >{{ station.id }}{{ idx < selectedStations.length - 1 ? ',' : '' }}
      </span>
      <button class="btn btn-sm btn-primary" @click="applyStationsFilter">Apply</button>
      <button class="btn btn-sm btn-primary" @click="cancelStationsFilter">Cancel</button>
    </div> -->
      <a href="http://mapbox.com/about/maps" class="mapbox-logo" :style="mapboxLogoBackground" target="_blank"
        >Mapbox</a
      >
    </div>
  </div>
</template>

<script>
import * as api from '@/lib/api'
import helpers from '@/lib/helpers'
import MapSelector from '@/components/MapSelector.vue'
const MAX_NUMBER_OF_FILTERS = 50

// L is the leaflet global module provided by script from CDN
export default {
  name: 'AssetMap',
  components: {
    MapSelector,
  },
  props: {
    wpData: {
      type: Object,
    },
    // allow parent to clear drawLayer
    value: Array,
    render: Boolean,
    validStations: Array,
    availableStations: Array,
    userCoords: Array,
    applyCoords: Boolean,
    numberOfSelectedFilters: Number,
    // networks: Array,
    // currentlySelectedStations: Array,
  },
  data() {
    return {
      map: null,
      drawLayer: null,
      editHandler: null,
      // stationsLayer: null,
      markersLayer: null,
      // otherStationsLayer: null,
      allStations: [],
      selectedStations: this.value,
      attribution: `© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>`,

      // '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>', //'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors', //'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
      // tilesUrl: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png', //'https://osmap.{s}.tile.mapcdn.net/en/map/v1/{z}/{x}/{y}.png', //'http://{s}.tile.osm.org/{z}/{x}/{y}.png', //'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      // tilesUrl: 'https://api.mapbox.com/v4/mapbox.mapbox-streets-v8/1/0/0.mvt?access_token=YOUR_MAPBOX_ACCESS_TOKEN', // Need access token to get it I think.
      // tilesUrl: 'https://api.mapbox.com/v4/mapbox.mapbox-streets-v8/{z}/{x}/{y}@2x.jpg90?access_token=pk.eyJ1IjoiZnJhbnRvcnRvc2EiLCJhIjoiY2x0YnE0dWZpMWpuNjJucnhlZzM0ajFqdyJ9.c_wgwsVbenuO7WIPDT0_lQ',

      tilesUrl:
        'https://api.mapbox.com/styles/v1/mapbox/streets-v10/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZ3NzYy1zdXBwb3J0IiwiYSI6ImNsdHFjZ3F4djA0cm0ybm5qZ2FwN2Z4ZmcifQ.8oBqZ0rZnsHSZyT_CqIaVw',
      // tilesUrl:
      //   'https://api.mapbox.com/styles/v1/frantortosa/cltdatdt6010401pjbiq7htbp/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZnJhbnRvcnRvc2EiLCJhIjoiY2x0YnBhZ3NzMWt6ZjJqcXJ2OTMxcHlwaCJ9.Ew6kBMiNQdFdw-XMqKoiZQ',
      status: [],
      selectedStatus: [],
      // name array of available
      availableNetworks: [],
      // name array of selected
      selectedNetworks: [],
      // tree with network labels and children *boskettree
      selectedNetworksTree: [],

      ///// HOVER MAP 'CLICK TO INTERACT FEATURE' //////
      mapOnFocus: false,
      onHover: false,
      showOverlay: false,
      //////////////////////////////////////////////////
      clusterOn: true,
      unselectableStationsLayer: null,
      allNetworks: [],
      newSelectedStationsCount: 0,
    }
  },
  computed: {
    mapboxLogoBackground() {
      const imagePath = this.wpData.image_path + 'mapbox-logo-black.svg'
      console.log('path', imagePath)
      return {
        'background-image': `url('${imagePath}')`,
      }
    },
    coords() {
      // return an array of coordinates representing a rectangle
      // format: [lat1, long1, lat2, long2]
      // lat1, long1 is the top right corner of the rectangle
      // lat2, long2 is the bottom left corner
      // this format is suitable for assets API request

      // getLatLngs is an array of 4 points
      // point 1 = bottom left, subsequent points rotate clockwise

      if (this.drawLayer) {
        const points = this.drawLayer.getLatLngs()[0]
        return [
          helpers.between(points[2].lat.toFixed(5), -90, 90),
          helpers.between(points[2].lng.toFixed(5), -180, 180),
          helpers.between(points[0].lat.toFixed(5), -90, 90),
          helpers.between(points[0].lng.toFixed(5), -180, 180),
        ]
      }

      return []
    },
    // tree with network labels and children *boskettree
    availableNetworksTree() {
      const IGSNetworks = [
        'IGS',
        'IGS Multi-GNSS',
        'IGS14',
        'IGS14 Core',
        'RTS',
        'Former IGS',
        'IGS08',
        'IGS08 Core',
        'IGS Experimental',
        'Former MGEX',
      ]
      let networksTree = []
      this.availableNetworks.forEach((network) => {
        if (IGSNetworks.includes(network)) {
          let IGSNodeIndex = networksTree.findIndex((network) => network.label === 'IGS')
          if (IGSNodeIndex !== -1) {
            // console.log('IGS IS INCLUDED')
          } else {
            networksTree.push({ label: 'IGS' })
          }
          IGSNodeIndex = networksTree.findIndex((network) => network.label === 'IGS')
          if (!('children' in networksTree[IGSNodeIndex])) {
            // console.log('NO CHILDREN')
            networksTree[IGSNodeIndex].children = [{ label: network }]
          } else {
            networksTree[IGSNodeIndex].children.push({ label: network })
          }
        } else {
          networksTree.push({ label: network })
        }
      })
      networksTree.sort((a, b) => (a.label === 'EUREF' && -1) || (b.label === 'EUREF' && 1) || 0)
      //return this.availableNetworks.map((el) => ({ label: el }))
      return networksTree
    },
    // selectedNetworksNameArray() {
    //   let selectedNetworksNameArray = []
    //   this.selectedNetworks.forEach((networkGroup) => {
    //     selectedNetworksNameArray.push(networkGroup.label)
    //     if (networkGroup.children) {
    //       selectedNetworksNameArray.push(...networkGroup.children.map((el) => el.label))
    //     }
    //     console.log('NAME ARRAY', selectedNetworksNameArray)
    //   })
    //   return selectedNetworksNameArray
    // },
    // allStationsWithAssets() {
    //   return this.allStations.filter((station) => this.availableStations.includes(station.id))
    // },
    allNetworksSelected() {
      const rootAvailableNetworkNames = this.availableNetworksTree.map((el) => el.label)
      if (rootAvailableNetworkNames.every((el) => this.selectedNetworks.includes(el))) {
        return true
      } else {
        return false
      }
    },
    allStatusSelected() {
      if (this.status.every((el) => this.selectedStatus.includes(el))) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    initMap() {
      // Setup rectangle tooltip
      L.drawLocal.draw.toolbar.buttons.rectangle = 'Select area'
      const tileLayer = L.tileLayer(this.tilesUrl, {
        attribution: this.attribution,
        noWrap: true,
        bounds: [[-90, -180], [90, 180]],
        // tileSize y zoomOffset son para que la fuente se lea mejor (era muy pequeña)
        tileSize: 512,
        zoomOffset: -1,
      })
      const corner1 = L.latLng(180, -270),
        corner2 = L.latLng(-180, 270),
        bounds = L.latLngBounds(corner1, corner2)
      this.map = L.map('assets__map', {
        center: [10, 10],
        zoom: 2,
        minZoom: 1,
        maxZoom: 14,
        maxBounds: bounds,
        maxBoundsViscosity: 0.8,
        preferCanvas: true,
        ///// HOVER MAP 'CLICK TO INTERACT FEATURE' //////
        // scrollWheelZoom: false,
        //////////////////////////////////////////////////
      }).addLayer(tileLayer)

      ///// HOVER MAP 'CLICK TO INTERACT FEATURE' //////
      // this.map.on('focus', () => {
      //   this.map.scrollWheelZoom.enable()
      //   this.map.dragging.enable()
      //   this.map.touchZoom.enable()
      //   this.map.doubleClickZoom.enable()
      //   this.map.scrollWheelZoom.enable()
      //   this.map.boxZoom.enable()
      //   this.map.keyboard.enable()
      //   if (this.map.tap) this.map.tap.enable()
      //   document.getElementById('assets__map').style.cursor = 'grab'
      //   this.mapOnFocus = true
      //   this.showOverlay = false
      // })
      // this.map.on('blur', () => {
      //   this.map.scrollWheelZoom.disable()
      //   this.map.dragging.disable()
      //   this.map.touchZoom.disable()
      //   this.map.doubleClickZoom.disable()
      //   this.map.scrollWheelZoom.disable()
      //   this.map.boxZoom.disable()
      //   this.map.keyboard.disable()
      //   if (this.map.tap) this.map.tap.disable()
      //   document.getElementById('assets__map').style.cursor = 'default'
      //   this.mapOnFocus = false
      // })
      //////////////////////////////////////////////////

      // manually create an edit toolbar (which won't be visible) when the page loads
      let toolbar = new L.EditToolbar({
        featureGroup: new L.FeatureGroup(),
      })
      // save reference to edit handler to programatically enable edit mode later
      this.editHandler = toolbar.getModeHandlers()[0].handler
      // Drawing controls
      let drawControl = new L.Control.Draw({
        draw: {
          circle: false,
          polyline: false,
          polygon: false,
          marker: false,
          circlemarker: false,
          rectangle: {
            shapeOptions: {
              stroke: false,
              color: '#335e6f',
              weight: 1,
              showArea: false,
              showRadius: false,
            },
            showArea: false,
            showRadius: false,
          },
        },
        edit: false,
      })
      this.map.addControl(drawControl)

      // Handlers to save drawn layer and coordinates
      this.map.on(L.Draw.Event.CREATED, (e) => {
        // Add the layer to the map and enable editing immediately
        this.drawLayer = e.layer
        // TODO: uncomment edit possible on mobile only
        // TODO: bring "isMobile" helper from bepi.
        // this.editHandler._enableLayerEdit(this.drawLayer)
        this.drawLayer.addTo(this.map)
        // getLatLngs return nested array of multiline points
        this.coordsChanged()
      })

      // Handler to ensure one draw layer only
      this.map.on(L.Draw.Event.DRAWSTART, (e) => {
        // Remove previous draw if present
        if (this.drawLayer) {
          this.drawLayer.remove()
        }
      })

      // Handler to emit coords when layer is edited
      this.map.on(L.Draw.Event.EDITMOVE, (e) => {
        this.coordsChanged()
      })

      // Handler to emit coords when layer is moved
      this.map.on(L.Draw.Event.EDITRESIZE, (e) => {
        this.coordsChanged()
      })
      // // Create legend
      // let legend = L.control({ position: 'bottomleft' })
      // legend.onAdd = function(map) {
      //   var div = L.DomUtil.create('div', 'info legend'),
      //     grades = [0, 10, 20, 50, 100, 200, 500, 1000],
      //     labels = []
      //   // loop through our density intervals and generate a label with a colored square for each interval
      //   div.innerHTML += '<h4>Status</h4>'
      //   div.innerHTML += '<i class="icon" style="border-color: #008e7a"></i><span>Ok</span><br>'
      //   div.innerHTML += '<i class="icon" style="border-color: #E09D00"></i><span>Warning</span><br>'
      //   div.innerHTML += '<i class="icon" style="border-color: #ed1b2f"></i><span>Error</span><br>'
      //   // div.innerHTML += '<i class="icon" style="border-color: #ccc"></i><span>Filtered</span><br>'
      //   div.innerHTML += '<i class="icon" style="border-color: #002664"></i><span>Unknown</span><br>'
      //   // div.innerHTML += '<i class="icon" style="border-color: #00549F"></i><span>Other</span><br>'
      //   return div
      // }
      // legend.addTo(this.map)

      // this.stationsLayer = new L.layerGroup().addTo(this.map)
      this.markersLayer = new L.markerClusterGroup({
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        // disableClusteringAtZoom: 6,
        // maxClusterRadius: 100,
      }).addTo(this.map)
      // this.otherStationsLayer = new L.layerGroup()
      this.unselectableStationsLayer = new L.layerGroup() //.addTo(this.map)
    },
    async getStations() {
      const response = await api.getStations() //{ size: 100 });
      this.$emit('mapStations', response.results)
      // promise to wait for validStations extracted from assets
      await this.waitForValidStations()
      // console.log('VALID STATIONS - ALL STATIONS', response)
      console.log('BEFORE FILTER STATIONS')
      // TODO: consider using .has() apparently it is more efficient than filter and .includes !!!
      this.allStations = response.results.filter((station) => this.validStations.includes(station.id))

      // STATION TESTS /////////////////////////////////////
      const otherStations = this.availableStations.filter(
        (station) => !response.results.map((el) => el.id).includes(station)
      )
      // TODO: consider using .has() apparently it is more efficient than filter and .includes !!!
      const yesInStations = this.availableStations.filter((station) =>
        response.results.map((el) => el.id).includes(station)
      )
      const stationsWithoutAssets = response.results
        .filter((station) => !this.availableStations.includes(station.id))
        .map((el) => el.id)
      // console.log('STATIONS-ANALYSIS GET STATIONS', response.results.map((el) => el.id))
      // console.log('STATIONS-ANALYSIS FROM ASSETS', this.availableStations)
      // console.log('STATIONS-ANALYSIS NOT IN GETSTATIONS', otherStations)
      // console.log('STATIONS-ANALYSIS YES IN GETSTATIONS', yesInStations)
      // console.log('STATIONS-ANALYSIS IN STATIONS NOT IN ASSETS', stationsWithoutAssets)
      // console.log('OTHERSTATIONS valid', this.validStations)
      /////////////////////////////////////////////////////////

      console.log('AFTER FILTER STATIONS')

      // var markers = L.markerClusterGroup({
      //   spiderfyOnMaxZoom: true,
      //   showCoverageOnHover: false,
      //   zoomToBoundsOnClick: true,
      // })

      // place station markers on map
      this.allStations.forEach((station) => {
        let color = '#00549F'
        switch (station.status) {
          case 'OK':
            color = '#008e7a'
            break
          case 'ERROR':
            color = '#ed1b2f'
            break
          case 'UNKNOWN':
            color = '#00549F'
            break
          case 'WARNING':
            color = '#E09D00'
            break
          default:
            color = '#ffff00'
          // code block
        }
        // cover against stations without position
        if (!station.position) return
        // mark stations UNKNOWN and undefined as "UNKNOWN"
        // if (station.status === 'UNKNOWN' || station.status === undefined) {
        //   station.status === 'UNKNOWN'
        // }

        // set all stations as selectable

        L.circleMarker([station.position.lat, station.position.long], {
          color: color,
          radius: 6,
          // fill: true,
          weight: 2,
          // fillColor: '#fff',
          station: station,
          selectable: true,
          // fillOpacity: 1
        })
          .bindTooltip(
            `<div><strong>Id: </strong>${station.id}</div>
          <div><strong>Agency: </strong>${station.agency}</div>
          <div><strong>Last Date: </strong>${station.last_date}</div>
          <div><strong>Observer: </strong>${station.observer} </div>
          <div><strong>IERS DOMES Number: </strong>${station.IERS_DOMES_Number} </div>
          <div><strong>Networks: </strong>${station.networks}</div>
          <div><strong>Count: </strong>${station.count}</div>
          <div><strong>Status: </strong>${station.status}</div>
          <div><strong>Coordinates: </strong>${station.position.lat}º ${station.position.long}º</div>`
          )
          .on('click', this.stationClicked)
          // .addTo(this.stationsLayer)
          .addTo(this.markersLayer)
        // .addTo(this.otherStationsLayer)
      })

      // console.log('MARKERS', markers)
      // this.markersLayer.eachLayer((layer) => {
      //   let cosita = layer.getChildCount()
      //   console.log('MARKERS', cosita)
      // })
      // console.log('MARKERS', this.markersLayer)

      // ejemplo de bindtooltip con más opciones
      // .bindTooltip(function (layer) {
      //   return layer.feature.properties.name; //merely sets the tooltip text
      //  }, {permanent: true, opacity: 0.5}  //then add your options

      // this.map.eachLayer((layer) =>
      //   layer.options.station ? console.log(layer.options.station.id) : console.log('NO STATION HERE'),
      // )
      setTimeout(() => this.map.invalidateSize(true), 1000)
    },
    stationClicked(e) {
      const target = e.target
      const indexOfStation = this.selectedStations.findIndex((item) => item == target.options.station.id)
      if (indexOfStation == -1) {
        this.selectStation(target)
      } else {
        this.unselectStation(target)
      }
      this.applyStationsFilter()
    },
    selectStation(target) {
      if (this.numberOfSelectedFilters + this.newSelectedStationsCount + 1 > MAX_NUMBER_OF_FILTERS) {
        console.log('MAX FILTERS REACHED')
        this.$emit('showMaxNumberOfFiltersModal')
        return
      } else {
        if (target.options.selectable) {
          // get station from options
          const station = target.options.station
          // Set style of marker as selected
          target.setStyle({ fillColor: '#335e6f', fillOpacity: 1 })
          // station was not selected -> add to Selected
          this.selectedStations.push(station.id)
          this.newSelectedStationsCount++
        }
      }
    },
    unselectStation(target) {
      if (target.options.selectable) {
        // find station within selectedStations
        const indexOfStation = this.selectedStations.findIndex((item) => item == target.options.station.id)
        // Set style of marker as Unselected
        target.setStyle({ fillColor: '#fff', fillOpacity: 0 })
        //station was selected -> Unselect station, remove from array
        this.selectedStations.splice(indexOfStation, 1)
        this.newSelectedStationsCount--
      }
    },
    coordsChanged() {
      //Similarly to station clicked must add all elements inside to the list of selectedStations if not already there, and fill color of them.
      // console.log('coordsChanged')
      // console.log('markers', this.markersLayer.getVisibleParent())
      let newSelection = []

      this.map.eachLayer((layer) => {
        if (layer.getChildCount) {
          // if layer is markerCluster, select all stations inside
          const markerClusterIsInside = this.drawLayer.getBounds().contains(layer.getLatLng())
          if (markerClusterIsInside) {
            console.log('markersclusters', layer._childCount, markerClusterIsInside)
            console.log('markersInside', layer.getAllChildMarkers())
            layer.getAllChildMarkers().forEach((layer) => {
              const indexOfStation = this.selectedStations.findIndex((item) => item == layer.options.station.id)
              if (indexOfStation == -1 && layer.options.selectable) newSelection.push(layer) //this.selectStation(layer)
            })
          }
        }
      })
      this.markersLayer.eachLayer((layer) => {
        const stationIsInside = this.drawLayer.getBounds().contains(layer.getLatLng())
        const indexOfStation = this.selectedStations.findIndex((item) => item == layer.options.station.id)
        if (stationIsInside && indexOfStation == -1 && layer.options.selectable) {
          // if element is not Clustered
          const hasLayer = this.map.hasLayer(layer)
          if (hasLayer) {
            newSelection.push(layer) //this.selectStation(layer)
          }
        }
      })
      if (this.numberOfSelectedFilters + newSelection.length <= MAX_NUMBER_OF_FILTERS) {
        newSelection.forEach((layer) => this.selectStation(layer))
      } else {
        console.log('MAX FILTERS REACHED')
        this.$emit('showMaxNumberOfFiltersModal')
      }

      this.applyStationsFilter()
      this.drawLayer.remove()
      // this.$emit('change', this.coords)
    },
    applyStationsFilter() {
      // remove previously selected stations from the side menu
      this.$emit('input', this.selectedStations)
      this.newSelectedStationsCount = 0
      // this.stationsLayer.eachLayer((layer) => layer.setStyle({ fillColor: '#fff', fillOpacity: 0 }))
    },
    // cancelStationsFilter() {
    //   this.stationsLayer.eachLayer((layer) => layer.setStyle({ fillColor: '#fff', fillOpacity: 0 }))
    //   this.selectedStations = []
    // },
    highlightCurrentlySelected() {
      // this.selectedStations = this.currentlySelectedStations //this.allStations.filter((station) => this.currentlySelectedStations.includes(station.id))
      // console.log('stationsssss', this.selectedStations)
      // console.log('stationsssssssss', this.stationsLayer)
      this.markersLayer.eachLayer((layer) => {
        const indexOfStation = this.value.findIndex((item) => item == layer.options.station.id)
        if (indexOfStation != -1) {
          layer.setStyle({ fillColor: '#335e6f', fillOpacity: 1 })
        } else {
          layer.setStyle({ fillColor: '#fff', fillOpacity: 0 })
        }
      })
    },
    selectableChanged() {
      // console.log('SELECTED NETWORKS', this.selectedNetworks)
      let newSelectedNetworks = []
      this.selectedNetworksTree.forEach((networkGroup) => {
        newSelectedNetworks.push(networkGroup.label)
        if (networkGroup.children) {
          newSelectedNetworks.push(...networkGroup.children.map((el) => el.label))
        }
      })
      this.selectedNetworks = newSelectedNetworks

      // mark selectable only those with the corresponding status & networks
      const selectableStations = []
      // Each station check status & networks
      this.markersLayer.eachLayer((layer) => {
        // console.log('networks', layer.options.station.networks)
        // Clean array of networks from station string
        const cleanNetworks = layer.options.station.networks
          ? this.availableNetworks.filter((network) => layer.options.station.networks.includes(network))
          : ['Undefined']

        // console.log('cleanNetworks', cleanNetworks)
        // Selectable if status is in selectedStatus and some network in selectedNetworks

        // UNCOMMENT NETWORKS PART WHEN READY TO DEPLOY
        layer.options.selectable =
          this.selectedStatus.includes(layer.options.station.status) &&
          this.availableStations.includes(layer.options.station.id) &&
          cleanNetworks.some((network) => this.selectedNetworks.includes(network))

        // If this layer is selectable, push it to selectableStations
        layer.options.selectable ? selectableStations.push(layer.options.station.id) : null
      })
      this.unselectableStationsLayer.eachLayer((layer) => {
        // Clean array of networks from station string
        const cleanNetworks = layer.options.station.networks
          ? this.availableNetworks.filter((network) => layer.options.station.networks.includes(network))
          : ['Undefined']

        layer.options.selectable =
          this.selectedStatus.includes(layer.options.station.status) &&
          this.availableStations.includes(layer.options.station.id) &&
          cleanNetworks.some((network) => this.selectedNetworks.includes(network))

        // If this layer is selectable, push it to selectableStations
        layer.options.selectable ? selectableStations.push(layer.options.station.id) : null
      })

      this.markersLayer.eachLayer((layer) => {
        if (!layer.options.selectable) {
          this.markersLayer.removeLayer(layer)
          this.unselectableStationsLayer.addLayer(layer)
        }
      })
      this.unselectableStationsLayer.eachLayer((layer) => {
        if (layer.options.selectable) {
          this.markersLayer.addLayer(layer)
          this.unselectableStationsLayer.removeLayer(layer)
        }
      })
      // console.log('selectable', selectableStations)
      // remove unselectable stations from current selection
      this.selectedStations = this.selectedStations.filter((station) => selectableStations.includes(station))
      // console.log('status', this.selectedStations)
      // apply new filter
      this.applyStationsFilter()
      // updated color visualization
      this.updateStationsStatusColors()
    },
    updateStationsStatusColors() {
      this.markersLayer.eachLayer((layer) => {
        let color = '#00549F'
        if (layer.options.selectable) {
          switch (layer.options.station.status) {
            case 'OK':
              color = '#008e7a'
              break
            case 'ERROR':
              color = '#ed1b2f'
              break
            case 'UNKNOWN':
              color = '#00549F'
              break
            case 'WARNING':
              color = '#E09D00'
              break
            default:
              color = '#ffff00'
          }
        } else {
          // layer not selectable
          color = '#ccc'
        }
        layer.setStyle({ color: color })
      })
    },
    async waitForValidStations() {
      return new Promise((resolve) => {
        // if (this.validStations) {
        //   return resolve(this.validStations)
        // }
        const loop = () => (this.validStations !== undefined ? resolve(this.validStations) : setTimeout(loop))
        loop()
      })
    },
    toggleCluster() {
      this.clusterOn = !this.clusterOn
      console.log('markers', this.markersLayer)
      if (this.clusterOn) {
        this.markersLayer.enableClustering()
      } else {
        this.markersLayer.disableClustering()
      }
    },
    ///// HOVER MAP 'CLICK TO INTERACT FEATURE' //////
    // hover() {
    //   this.onHover = true
    //   setTimeout(() => {
    //     if (!this.mapOnFocus && this.onHover) {
    //       this.showOverlay = true
    //     } else {
    //       this.showOverlay = false
    //     }
    //   }, 3000)
    // },
    // unhover() {
    //   this.onHover = false
    //   this.showOverlay = false
    // },
    // removeOverlay() {
    //   this.showOverlay = false
    //   this.map.focus()
    // },
    //////////////////////////////////////////////////
  },
  watch: {
    userCoords(val) {
      // if (this.drawLayer) {
      //   // remove draw layer if coords has been altered from parent
      //   if (val.length === 4) {
      //     for (let i = 0; i < val.length; i++) {
      //       if (val[i] != this.coords[i]) {
      //         this.drawLayer.remove()
      //         return
      //       }
      //     }
      //   } else if (val.length === 0) {
      //     this.drawLayer.remove()
      //   }
      // }
      if (this.drawLayer) {
        this.drawLayer.remove()
      }
      if (val.length === 4) {
        const corner1 = L.latLng(val[0], val[1])
        const corner2 = L.latLng(val[2], val[3])
        const bounds = L.latLngBounds(corner1, corner2)
        this.drawLayer = L.rectangle(bounds, {
          color: '#335e6f',
          weight: 2,
        })
        this.drawLayer.addTo(this.map)
        // console.log(this.drawLayer)
      }
    },
    applyCoords() {
      this.coordsChanged()
    },
    value(val) {
      if (Array.isArray(val)) {
        this.highlightCurrentlySelected()
        this.selectedStations = val
        // console.log('NewStationssss  WATCHER', this.selectedStations)
        // update selected stations for parent
        // this.applyStationsFilter()
      }
    },
    render(val) {
      this.map.invalidateSize(true)
    },
    availableStations() {
      this.selectableChanged()
    },
    // validStations() {
    //   console.log('STATIONS CHANGED VALID')
    //   this.stationsLayer.eachLayer((layer) => {
    //     const indexOfStation = this.validStations.findIndex((stationId) => stationId == layer.options.station.id)
    //     if (indexOfStation == -1) {
    //       layer.remove()
    //       // layer.setStyle({ fillColor: '#ff0', fillOpacity: 1 })
    //     }
    //   })
    // },
    // setupLeaflet() {
    //   // some items need to be initialized first
    //   L.drawLocal = {
    //     draw: {
    //       toolbar: {
    //         buttons: {
    //           rectangle: 'This'
    //         }
    //       }
    //     }
    //   }
    // }
  },
  async mounted() {
    // this.setupLeaflet()
    this.initMap()
    console.log('STATIONS 2')
    await this.getStations()
    // console.log('stations with ass', this.allStationsWithAssets)
    // console.log('stations av', this.availableStations)
    // console.log('stations all', this.allStations)
    // console.log('NewStationssss1  MOUNTED1', this.allStations)
    this.allNetworks = this.allStations
      .map((station) => station.networks)
      .filter((item) => item != undefined)
      .reduce((acc, cur) => {
        // console.log('NewStationssss1', cur)
        acc.push(...cur.split(','))
        acc = [...new Set(acc)]
        return acc
      }, [])
    // this.networks = networks

    ///////////
    // THIS IS THE GOOD ONE
    ///////////

    //Obtain availableNetworks from networks
    this.markersLayer.eachLayer((layer) => {
      // console.log('networks', layer.options.station.networks)
      // Clean array of networks from station string
      // console.log('NETWORKS', layer.options.station.networks)
      const cleanNetworks = layer.options.station.networks
        ? this.allNetworks.filter((network) => layer.options.station.networks.includes(network))
        : ['Undefined']

      // cleanNetworks.forEach((network) => {
      //   this.availableNetworks.indexOf(network) === -1 ? this.availableNetworks.push(network) : null
      // })

      cleanNetworks.forEach((network) => {
        this.availableNetworks.indexOf(network) === -1 ? this.availableNetworks.push(network) : null
      })

      // cleanNetworks.forEach((network) => {
      //   this.availableNetworks.find((net) => net.label === network)
      //     ? null
      //     : this.availableNetworks.push({ label: network })
      // })
    })

    // console.log('NETWORKS', this.availableNetworks)
    this.selectedNetworks = [...this.availableNetworks]
    this.selectedNetworksTree = [...this.availableNetworksTree]
    // console.log('NETWORKSTREE', this.selectedNetworksTree)

    ///////////
    // THIS IS THE GOOD ONE TILL HERE
    ///////////
    // this.availableNetworks = []
    // this.selectedNetworks = []

    // console.log('NewStationsss1 REDUCE ', networks)
    // console.log('NewStationssss1  MOUNTED2', this.allStations.map((station) => station.networks).forEach)
    // console.log('NewStationssss2', [
    //   ...new Set(this.allStations.map((station) => station.status).filter((item) => item != undefined)),
    // ])
    this.status = [...new Set(this.allStations.map((station) => station.status).filter((item) => item != undefined))]
    // console.log('NewStationss status', this.status)
    this.selectedStatus = [...this.status]
    // console.log('NewStationss selectedstatus', this.selectedStatus)
    if (Array.isArray(this.value)) {
      this.highlightCurrentlySelected()
      // update selected stations for parent
      // this.applyStationsFilter()
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~@/styles/globals';

.assets__map {
  height: 460px;

  &-wrapper {
    height: 460px;
    position: relative;
  }
  &-overlay {
    // pointer-events: none;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    // background-color: rgba(0, 0, 0, 0.1);
    background: radial-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.1));
    color: white;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    margin: auto;
    height: 460px;
    line-height: 460px;
    z-index: 1000;
  }
  &-canvas {
    height: 460px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  // &--stations-selected {
  //   position: absolute;
  //   left: 52px;
  //   top: 11px;
  //   padding-left: 5px;
  //   z-index: 1000;
  //   background: rgba(255, 255, 255, 0.6);
  // }

  &-filter-button {
    position: absolute !important;
    font-family: Helvetica, sans-serif;
    left: 10px;
    z-index: 1000;
    font-size: 14px;
    width: 34px;

    button {
      background: white;
      width: 30px;
      height: 30px;
      padding: 6px;
    }

    border: 2px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;

    //buttons: top: 128px, 170px, 212px

    &.network {
      top: 172px;

      & .dropdown-menu {
        min-width: 200px;

        ul {
          display: flex;
          flex-direction: column;
          // grid-template-columns: repeat(2, 1fr);
        }
      }
    }

    &.cluster {
      top: 128px;
    }

    &.status {
      top: 216px;
    }

    button {
      border-radius: 2px;
      &.button-on {
        background-color: $primary;
        color: white;
      }
    }

    & .dropdown-menu {
      background: rgba(255, 255, 255, 0.95);
      border: 2px solid rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      top: -2px !important;
      min-width: 100px;
    }
  }

  &-filter-icon {
    font-size: 18px;
  }
}

/*Legend specific*/
// .legend {
//   padding: 6px 8px;
//   font: 14px Arial, Helvetica, sans-serif;
//   background: white;
//   background: rgba(255, 255, 255, 0.8);
//   /*box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);*/
//   /*border-radius: 5px;*/
//   line-height: 24px;
//   color: #555;
// }

// .legend h4 {
//   text-align: center;
//   font-size: 16px;
//   margin: 2px 12px 8px;
//   color: #777;
// }

// .legend span {
//   position: relative;
//   bottom: 3px;
// }

// .legend i {
//   width: 10px;
//   height: 10px;
//   float: left;
//   margin: 0 8px 0 0;
//   opacity: 0.7;
// }

// .legend i.icon {
//   /* background-size: 18px; */
//   border: 2px solid rgba(255, 255, 255, 1);
//   border-radius: 50%;
//   margin-top: 4px;
//   padding: 3px;
// }

.leaflet-draw-draw-rectangle {
  background: white !important;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    top: 50%;
    border: 2px dashed black;
  }

  &.leaflet-draw-toolbar-button-enabled {
    background: $primary !important;

    &::after {
      border: 1px dashed white;
    }
  }
}

.leaflet-draw-actions {
  li {
    a {
      position: absolute;
      left: -30px;
      height: 30px !important;
      overflow: hidden;
      width: 30px;
      color: transparent;
      top: 0;
      background: none;

      &:hover {
        background: none;
      }
    }
  }
}
.marker-cluster-large {
  background-color: color-mix(in srgb, $primary 50%, transparent);
  color: white;
  div {
    background-color: $primary;
  }
}
.marker-cluster-medium {
  background-color: color-mix(in srgb, $primary 40%, transparent);
  color: white;
  div {
    background-color: color-mix(in srgb, $primary 75%, transparent);
  }
}
.marker-cluster-small {
  background-color: color-mix(in srgb, $primary 25%, transparent);
  color: white;
  div {
    background-color: color-mix(in srgb, $primary 50%, transparent);
  }
}
.mapbox-logo {
  position: absolute;
  display: block;
  height: 20px;
  width: 65px;
  left: 10px;
  bottom: 10px;
  text-indent: -9999px;
  z-index: 99999;
  overflow: hidden;

  /* `background-image` contains the Mapbox logo */
  background-image: url('/img/mapbox-logo-black.svg');
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 65px 20px;
}
</style>
